import { differenceInYears } from "date-fns";

const MINOR_AGE_THRESHOLD = 18;

/**
 * Checks if a date of birth indicates a minor (under 18 years old)
 *
 * @param dateOfBirth - The date of birth as a Date object
 * @returns boolean - Whether the person is a minor
 */
export const isMinor = (dateOfBirth: Date): boolean => {
  if (!(dateOfBirth instanceof Date) || isNaN(dateOfBirth.getTime())) {
    return false;
  }

  return differenceInYears(new Date(), dateOfBirth) < MINOR_AGE_THRESHOLD;
};
